import WidgetBarcode from 'components/Widgets/WidgetBarcode';

const BarcodeTypeField = ({ barcodes, setNewSelectItem, selectItem, disabled }) => {
  return (
    <WidgetBarcode
      availableBarcodes={barcodes}
      onChange={setNewSelectItem}
      value={selectItem}
      disabled={disabled}
    />
  );
};

export default BarcodeTypeField;
